export default __webpack_public_path__ + "static/media/ProjectsIcon.9a07ac3a.svg";